// extracted by mini-css-extract-plugin
export default {"value":"UserData_value__6RmDx"};